/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Verification method type for DIDs */
export enum VerificationMethodType {
  Ed25519VerificationKey2020,
  X25519KeyAgreementKey2020,
  EcdsaSecp256k1VerificationKey2019,
}

export type VerificationMethodTypeArgs = VerificationMethodType;

export function getVerificationMethodTypeEncoder(): FixedSizeEncoder<VerificationMethodTypeArgs> {
  return getEnumEncoder(VerificationMethodType);
}

export function getVerificationMethodTypeDecoder(): FixedSizeDecoder<VerificationMethodType> {
  return getEnumDecoder(VerificationMethodType);
}

export function getVerificationMethodTypeCodec(): FixedSizeCodec<
  VerificationMethodTypeArgs,
  VerificationMethodType
> {
  return combineCodec(
    getVerificationMethodTypeEncoder(),
    getVerificationMethodTypeDecoder(),
  );
}
